import React, { createContext, useContext, ReactNode } from 'react';

interface FeatureFlagsContextType {
  flags: Record<string, boolean>;
}

const FeatureFlagsContext = createContext<FeatureFlagsContextType | undefined>(undefined);

interface FeatureFlagsProviderProps {
  value: Record<string, boolean>;
  children: ReactNode;
}

export const FeatureFlagsProvider: React.FC<FeatureFlagsProviderProps> = ({ value, children }) => {
  return (
    <FeatureFlagsContext.Provider value={{ flags: value }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export const useFlag = (flagName: string): boolean => {
  const context = useContext(FeatureFlagsContext);
  if (context === undefined) {
    throw new Error('useFlag must be used within a FeatureFlagsProvider');
  }
  return context.flags[flagName] ?? false;
};

export const useFlags = (): Record<string, boolean> => {
  const context = useContext(FeatureFlagsContext);
  if (context === undefined) {
    throw new Error('useFlags must be used within a FeatureFlagsProvider');
  }
  return context.flags;
};
